import { Map, List } from 'immutable'
import {
  CREATE_INVITES_START,
  CREATE_INVITES_SUCCESS,
  CREATE_INVITES_ERROR,
  DELETE_INVITE_START,
  DELETE_INVITE_SUCCESS,
  DELETE_INVITE_ERROR,
  RESEND_INVITE_START,
  RESEND_INVITE_SUCCESS,
  RESEND_INVITE_ERROR,
  FETCH_INVITES_START,
  FETCH_INVITES_SUCCESS,
  FETCH_INVITES_ERROR,
} from './actionTypes'

const initialState = Map({
  list: Map({
    data: [],
    loading: false,
    error: false,
  }),
  creation: Map({
    data: null,
    loading: false,
    error: false,
  }),
  resend: Map({
    inviteId: false,
    loading: false,
    error: false,
  }),
  delete: Map({
    inviteId: false,
    loading: false,
    error: false,
  }),
})

const invitesReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case CREATE_INVITES_START: {
      return state.merge({
        creation: { loading: true, data: null, error: false },
      })
    }
    case CREATE_INVITES_SUCCESS: {
      return state.mergeDeep({
        creation: { loading: false, data: payload },
        list: { data: List(payload).concat(state.get('list').get('data')) },
      })
    }
    case CREATE_INVITES_ERROR: {
      return state.merge({
        creation: { loading: false, data: payload, error: true },
      })
    }

    case DELETE_INVITE_START: {
      const { id } = meta.action.meta.invite
      return state.merge({
        delete: {
          [id]: { loading: true, error: false },
        },
      })
    }
    case DELETE_INVITE_SUCCESS: {
      const { id } = meta.action.meta.invite
      const listInvites = state.get('list').get('data')
      const indexes = listInvites.reduce((memoMap, invite, index) => {
        const inviteId = invite.id
        return memoMap.set(inviteId, index)
      }, Map())
      const index = indexes.get(id)
      return state.deleteIn(['list', 'data', index]).merge({
        delete: {
          [id]: { loading: false, error: false },
        },
      })
    }
    case DELETE_INVITE_ERROR: {
      const { id } = meta.action.meta.invite
      return state.merge({
        delete: {
          [id]: { loading: false, error: payload },
        },
      })
    }

    case RESEND_INVITE_START: {
      const { id } = meta.action.meta.invite
      return state.merge({
        resend: {
          [id]: { loading: true, error: false },
        },
      })
    }
    case RESEND_INVITE_SUCCESS: {
      const { id } = meta.action.meta.invite
      return state.merge({
        resend: {
          [id]: { loading: false, error: false },
        },
      })
    }
    case RESEND_INVITE_ERROR: {
      const { id } = meta.action.meta.invite
      return state.merge({
        resend: {
          [id]: { loading: false, error: payload },
        },
      })
    }

    case FETCH_INVITES_START: {
      return state.merge({
        list: { loading: true, data: List(), error: false },
      })
    }
    case FETCH_INVITES_SUCCESS: {
      return state.merge({
        list: { loading: false, data: payload },
      })
    }
    case FETCH_INVITES_ERROR: {
      return state.merge({
        list: { loading: false, data: payload, error: true },
      })
    }
    default:
      return state
  }
}

export default invitesReducer
